"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SafePairOfHandsStrategy = exports.SafePairOfHandsMode = exports.HitAndRunStrategy = exports.HitAndRunMode = exports.SidestepStrategy = exports.SidestepMode = exports.version = exports.TAKE_BALL_TYPE = exports.swapArrayLocs = exports.POSTULATION_HOURS = exports.PLAYER_STAT = exports.PLAYER_HISTORY_TYPE = exports.PLAYER_HISTORY_INFO = exports.p = exports.MAX_PLAYER_USER = exports.MAX_PLAYER_TEAM = exports.LAST_SEASON_ALPHA = exports.isSquareValidToPushBack = exports.allAdjacentSquaresToPushBack = exports.isSamePlayer = exports.isOnLine = exports.isOnField = exports.isCoach = exports.INACTIVE_DAYS = exports.haveSameTeam = exports.getThrowingBonus = exports.getTeamXP = exports.getTeamMoralByPlayer = exports.getTeamMoral = exports.getPlayerOnCell = exports.getMoralModifier = exports.getMaxPlayers = exports.getInactiveDays = exports.getHypnoticGazeMalus = exports.getDicesBlock = exports.getDefenderStrength = exports.getBlockAssistance = exports.getBestInterceptor = exports.getAttackerStrength = exports.getAllAdjacentSquares = exports.GAME_HISTORY_TYPE = exports.GAME_HISTORY_INFO = exports.FORMATION_DEFAULT_NAME = exports.canPlayerIntercepts = exports.availableSquaresToPushBack = exports.arrayMove = void 0;
exports.addSeconds = addSeconds;
exports.canBlock = canBlock;
exports.canEndTurn = canEndTurn;
exports.canFaceUp = canFaceUp;
exports.canFoul = canFoul;
exports.canMove = canMove;
exports.canPass = canPass;
exports.canStandup = canStandup;
exports.canThrowTeamMate = canThrowTeamMate;
exports.canTransmit = canTransmit;
exports.getTeamColor = getTeamColor;
exports.isGameRunning = isGameRunning;
exports.isSetUp = isSetUp;
const calcul_1 = require("./calcul");
const game_1 = require("./game");
const improvement_1 = require("./improvement");
const meteo_1 = require("./meteo");
const player_1 = require("./player");
const position_1 = require("./position");
Object.defineProperty(exports, "getAllAdjacentSquares", { enumerable: true, get: function () { return position_1.getAllAdjacentSquares; } });
const race_1 = require("./race");
const skill_1 = require("./skill");
const status_1 = require("./status");
const version_1 = __importDefault(require("./version"));
exports.version = version_1.default;
const POSTULATION_HOURS = 24;
exports.POSTULATION_HOURS = POSTULATION_HOURS;
const INACTIVE_DAYS = 10;
exports.INACTIVE_DAYS = INACTIVE_DAYS;
const MAX_PLAYER_USER = 2;
exports.MAX_PLAYER_USER = MAX_PLAYER_USER;
const MAX_PLAYER_TEAM = 16;
exports.MAX_PLAYER_TEAM = MAX_PLAYER_TEAM;
const LAST_SEASON_ALPHA = 2;
exports.LAST_SEASON_ALPHA = LAST_SEASON_ALPHA;
const FORMATION_DEFAULT_NAME = "last-76a0754a5a5005e4a1"; // Avoid name conflict
exports.FORMATION_DEFAULT_NAME = FORMATION_DEFAULT_NAME;
const PLAYER_STAT = {
    BLITZ: "b",
    BLOCK_1D: "b1",
    BLOCK_2D: "b2",
    BLOCK_3D: "b3",
    BLOCK_ARMOR_FAIL: "baF",
    BLOCK_ARMOR_SUCCESS: "baS",
    BLOCK_ASSISTANCE_ATTACK: "baa",
    BLOCK_ASSISTANCE_DEFENSE: "bad",
    BLOCK_M2D: "bm2",
    BLOCK_M3D: "bm3",
    BLOCK_RESULT_1: "br1",
    BLOCK_RESULT_2: "br2",
    BLOCK_RESULT_3: "br3",
    BLOCK_RESULT_4: "br4",
    BLOCK_RESULT_5: "br5",
    CASUALTY_BADLY_HURT: "cbh",
    CASUALTY_DEAD: "cd",
    CASUALTY_LASTING_INJURY: "cli",
    CASUALTY_RECEIVE_BADLY_HURT: "crbh",
    CASUALTY_RECEIVE_DEAD_FULL_MOON: "crdfm",
    CASUALTY_RECEIVE_DEAD: "crd",
    CASUALTY_RECEIVE_LASTING_INJURY: "crli",
    CASUALTY_RECEIVE_SERIOUS_INJURY: "crsi",
    CASUALTY_RECEIVE_SERIOUSLY_HURT: "crsh",
    CASUALTY_SERIOUS_INJURY: "csi",
    CASUALTY_SERIOUSLY_HURT: "csh",
    DODGE_FAIL: "dF",
    DODGE_SUCCESS: "dS",
    EXPERIENCE_COACH: "expc",
    EXPERIENCE: "exp",
    FACEUP: "fu",
    FOUL_ASSISTANCE_ATTACK: "faa",
    FOUL_ASSISTANCE_DEFENSE: "fad",
    FOUL_FAIL: "fF",
    FOUL_RECEIVE: "fr",
    FOUL_SENDOFF: "fso",
    FOUL_SUCCESS: "fS",
    GAME_DRAW: "gd",
    GAME_LOSS: "gl",
    GAME_PLAYED: "gp",
    GAME_VICTORY: "gv",
    GAME: "g",
    GO_FOR_IT_1_FAIL: "gfi1F",
    GO_FOR_IT_1_SUCCESS: "gfi1S",
    HANDING_OFF_FAIL: "hoF",
    HANDING_OFF_SUCCESS: "hoS",
    INJURY_CASUALTY: "ic",
    INJURY_KNOCKED_DOWN: "ikd",
    INJURY_KO: "iko",
    INTERCEPTION_FAIL: "iF",
    INTERCEPTION_SUCCESS: "iS",
    JUMP_FAIL: "jf",
    JUMP_SUCCESS: "js",
    MOVE: "m",
    PASS_COMPLETED: "pc",
    PASS_FAIL: "pF",
    PASS_FUMBLE: "pfu",
    PASS_INTERCEPTED: "pi",
    PASS_NOT_COMPLETED: "pnc",
    PASS_PERFECT_COMPLETED: "ppc",
    PASS_PERFECT: "pp",
    RECEIVE_ARMOR_FAIL: "aF",
    RECEIVE_ARMOR_SUCCESS: "aS",
    RECEIVE_BLITZ: "rb",
    RECEIVE_BLOCK_1D: "rb1",
    RECEIVE_BLOCK_2D: "rb2",
    RECEIVE_BLOCK_3D: "rb3",
    RECEIVE_BLOCK_ARMOR_FAIL: "rbaF",
    RECEIVE_BLOCK_ARMOR_SUCCESS: "rbaS",
    RECEIVE_BLOCK_M2D: "rbm2",
    RECEIVE_BLOCK_M3D: "rbm3",
    RECEIVE_BLOCK_RESULT_1: "rbr1",
    RECEIVE_BLOCK_RESULT_2: "rbr2",
    RECEIVE_BLOCK_RESULT_3: "rbr3",
    RECEIVE_BLOCK_RESULT_4: "rbr4",
    RECEIVE_BLOCK_RESULT_5: "rbr5",
    RECEIVE_INJURY_CASUALTY: "ric",
    RECEIVE_INJURY_KNOCKED_DOWN: "rikd",
    RECEIVE_INJURY_KO: "riko",
    REROLL: "r",
    STANDUP: "su",
    TAKE_BALL_FAIL: "tbF",
    TAKE_BALL_REBOND_FAIL: "tbrF",
    TAKE_BALL_REBOND_SUCCESS: "tbrS",
    TAKE_BALL_SUCCESS: "tbS",
    TD: "td",
    TURNOVER: "t",
};
exports.PLAYER_STAT = PLAYER_STAT;
const GAME_HISTORY_TYPE = {
    BLOCK: "B",
    END_TURN: "ET",
    END: "END",
    FACEUP: "F",
    FOUL: "FO",
    KICKOFF: "K",
    MOVE: "M",
    PASS: "P",
    SETUP: "SETUP",
    SETUP_POSITION: "SPOS",
    STANDUP: "S",
    START: "START",
    TRANSMISSION: "T",
    VOMIT: "V",
    EVENT: "E",
};
exports.GAME_HISTORY_TYPE = GAME_HISTORY_TYPE;
const GAME_HISTORY_INFO = {
    APO: "apo",
    ARMOR: "ar",
    BALL: "ball",
    BLOCK: "b",
    BREATHE_FIRE: "brf",
    BRIBE: "br",
    CARAC_CHANGE: "cc",
    CASUALTY: "ca",
    CROWD_SURF: "crs",
    DODGE: "d",
    END_PO: "endpo",
    END_POP: "endpop",
    END_TURN: "et",
    EXP: "exp",
    FOUL: "f",
    GO_FOR_IT: "gfi",
    HANDICAP: "handi",
    HANDING_OFF: "ho",
    INDUCEMENT_HALFLING_MASTER_CHEF: "ihmc",
    INJURY: "in",
    INTERCEPTION: "i",
    JUMP_UP: "ju",
    KICKOFF: "k",
    KO: "ko",
    LANDING: "la",
    JUMP: "j",
    LEAP: "l", // DEPRECATED
    METEO: "met",
    MOVE: "m",
    PASS: "p",
    PUNT_DIRECTION: "puntd",
    PUNT_DISTANCE: "puntdist",
    PUNT_TO_CROWD: "puntc",
    PUNT_ON_PLAYER: "puntp",
    PUNT_SCATTER: "punts",
    PRO: "pro",
    REJECTION: "r",
    REROLL_COACH: "rc",
    REROLL_INITIAL: "rei",
    REROLL_METEO: "rm",
    REROLL_RACE_MALUS: "rrm",
    REROLL: "re",
    SECURE_BALL: "sb",
    SCATTER: "sc",
    SKILL_GAIN: "skg",
    SKILL_LOSS: "skl",
    SKILL: "sk",
    SPY: "spy",
    STAB: "stab",
    STANDUP: "st",
    START_FAN: "fan",
    STATUS: "s",
    TAKE_BALL: "t",
    TD: "td",
    THREATENING: "thr",
    THROW_TEAM_MATE: "ttm",
    BLOODLUST_BITE: "blb",
    BLOODLUST_NO_TARGET: "blnt",
    TURNOVER: "to",
};
exports.GAME_HISTORY_INFO = GAME_HISTORY_INFO;
const PLAYER_HISTORY_TYPE = {
    AGING: "ag",
    APOTHECARY: "apo",
    COACH_SKILL: "cs",
    CREATE_TEAM: "ct",
    CREATED: "c",
    DEAD: "d",
    EXP: "e",
    INACTIVE: "i",
    JOIN_TEAM: "jt",
    NEW_COACH: "nc",
    NI: "ni",
    POP: "pop",
    QUIT_COACH: "qc",
    QUIT_TEAM: "rt",
    RAZ: "raz",
    REDUCTION: "r",
    REMOVE_FROM_TEAM: "rt",
    RETIRED_END: "retend",
    RETIRED: "ret",
    SKILL: "s",
};
exports.PLAYER_HISTORY_TYPE = PLAYER_HISTORY_TYPE;
const PLAYER_HISTORY_INFO = {
    EXP_ASSIST: "eassist",
    EXP_BONUS: "ebonus",
    EXP_CAS: "ecas",
    EXP_COACH: "ecoach",
    EXP_COMP: "ecomp",
    EXP_FALL: "efall",
    EXP_INT: "eint",
    EXP_KO: "eko",
    EXP_TD: "etd",
};
exports.PLAYER_HISTORY_INFO = PLAYER_HISTORY_INFO;
var TAKE_BALL_TYPE;
(function (TAKE_BALL_TYPE) {
    TAKE_BALL_TYPE["CATCH_PASS"] = "pass";
    TAKE_BALL_TYPE["CATCH_HANDOFF"] = "hand-off";
    TAKE_BALL_TYPE["PICKUP"] = "pick-up";
    TAKE_BALL_TYPE["CATCH_BOUNCE"] = "bounce";
})(TAKE_BALL_TYPE || (exports.TAKE_BALL_TYPE = TAKE_BALL_TYPE = {}));
const p = (x, y) => {
    return { x: +x, y: +y };
};
exports.p = p;
function addSeconds(date, days) {
    const result = new Date(date);
    result.setSeconds(result.getSeconds() + days);
    return result;
}
const isSquareValidToPushBack = (availableSquares, targetIndex, players, w, h, busy = []) => {
    if (!availableSquares[targetIndex] ||
        availableSquares[targetIndex].x === null ||
        availableSquares[targetIndex].y === null) {
        return false;
    }
    const player = getPlayerOnCell(availableSquares[targetIndex].x, availableSquares[targetIndex].y, players);
    const onField = isOnField(availableSquares[targetIndex].x, availableSquares[targetIndex].y, w, h);
    const isBusy = busy.some((b) => b.x === availableSquares[targetIndex].x &&
        b.y === availableSquares[targetIndex].y);
    // There is a empty square, we can push on it
    if (!player && onField && !isBusy) {
        return true;
    }
    // All the spaces are full, we can't push back
    const noEmptySquares = availableSquares.every((point) => {
        if (point.x === null || point.y === null) {
            return false;
        }
        return (getPlayerOnCell(point.x, point.y, players) ||
            busy.some((b) => b.x === point.x && b.y === point.y) ||
            !isOnField(point.x, point.y, w, h));
    });
    return noEmptySquares;
};
exports.isSquareValidToPushBack = isSquareValidToPushBack;
const getPlayerOnCell = (x, y, players) => {
    if (x === null || y === null) {
        return false;
    }
    return Object.values(players).find((player) => player.x === x && player.y === y && (0, status_1.hasStatusOnField)(player));
};
exports.getPlayerOnCell = getPlayerOnCell;
const getHypnoticGazeMalus = (player, target, players) => {
    const adjacentEnemyPlayers = Object.values(players).filter((p) => {
        return (p.id !== target.id && // Not the target
            (0, status_1.hasStatusTacleZone)(p) && // Marking this player
            p.teamId !== player.teamId && // From the other team
            (0, position_1.isAdjacent)(p, player) // Adjacent
        );
    });
    return adjacentEnemyPlayers.length;
};
exports.getHypnoticGazeMalus = getHypnoticGazeMalus;
// The attacking coach must declare if any of his players will give
// an assist first, then the defending coach must add defensive
// assists with players from his team.In order to make an assist,
//   the player:
// 1. Must be adjacent to the enemy player involved in the block,
//   and...
// 2. Must not be in the tackle zone of any other player from the
// opposing team, and ...
// 3. Must be standing, and …
// 4. Must have his tackle zones.
const getBlockAssistance = (attackerPlayer, defenderPlayer, players, isAttacker = false, isFoul = false) => {
    const OtherPlayersThanInvolved = players.filter((player) => {
        return player.id !== attackerPlayer.id && player.id !== defenderPlayer.id;
    });
    const isValidAdjacentEnemy = (player, target) => {
        return ((0, status_1.hasStatusTacleZone)(player) &&
            (0, position_1.isAdjacent)(player, target) &&
            player.teamId !== target.teamId);
    };
    // 1. Must be adjacent to the enemy player involved in the block,
    // 3. Must be standing, and …
    // 5. Must not be Eye Gouged (cannot provide assists)
    const adjacentEnemyPlayers = OtherPlayersThanInvolved.filter((player) => {
        return isValidAdjacentEnemy(player, defenderPlayer) && (0, status_1.hasStatusCanAssist)(player);
    });
    // 2. Must not be in the tackle zone of any other player from the
    // opposing team, and ...
    const assistantPlayers = adjacentEnemyPlayers.filter((adjacentEnemyPlayer) => {
        let hasGard = false;
        if (!isFoul && (0, skill_1.hasSkill)(adjacentEnemyPlayer, skill_1.SKILL_NAMES.GUARD)) {
            hasGard = true;
            if (isAttacker && // player is the attacker player.
                [...OtherPlayersThanInvolved, defenderPlayer].some((player) => {
                    return (isValidAdjacentEnemy(player, adjacentEnemyPlayer) &&
                        (0, skill_1.hasSkill)(player, skill_1.SKILL_NAMES.DEFENSIVE));
                })) {
                hasGard = false;
            }
        }
        // Put the Boot In: can provide offensive assist on fouls even when marked
        const hasPutTheBootIn = isFoul &&
            isAttacker &&
            (0, skill_1.hasSkill)(adjacentEnemyPlayer, skill_1.SKILL_NAMES.PUT_THE_BOOT_IN);
        return (hasGard ||
            hasPutTheBootIn ||
            !OtherPlayersThanInvolved.some((player) => {
                return (
                // 4. Must have his tackle zones.
                isValidAdjacentEnemy(player, adjacentEnemyPlayer));
            }));
    });
    return assistantPlayers;
};
exports.getBlockAssistance = getBlockAssistance;
// If the players' strengths are EQUAL, one dice is rolled.
// If one player is STRONGER, two dice are rolled and the stronger
// player may choose which one is used.
// If one player is MORE THAN TWICE AS STRONG, three dice
// are rolled and the stronger player may choose which is used.
// Note that the coach of the player making the block always rolls
// the dice, but that the coach of the stronger player may choose
// which is used.
const getDicesBlock = (attackerStrength, defenderStrength) => {
    if (attackerStrength === defenderStrength) {
        return 1;
    }
    if (attackerStrength > defenderStrength * 2 ||
        attackerStrength * 2 < defenderStrength) {
        return 3;
    }
    return 2;
};
exports.getDicesBlock = getDicesBlock;
const haveSameTeam = (p1, p2) => {
    return p1.teamId === p2.teamId;
};
exports.haveSameTeam = haveSameTeam;
const isSamePlayer = (p1, p2) => {
    if (!p1 || !p2) {
        return false;
    }
    return p1.id === p2.id;
};
exports.isSamePlayer = isSamePlayer;
const availableSquaresToPushBack = (p1, p2) => {
    if (!(0, position_1.isAdjacent)(p1, p2) ||
        p1.x === null ||
        p1.y === null ||
        p2.x === null ||
        p2.y === null) {
        return [];
    }
    const xFrom = p1.x;
    const yFrom = p1.y;
    const xTo = p2.x;
    const yTo = p2.y;
    // From 1
    if (xFrom === xTo - 1 && yFrom === yTo - 1) {
        return [
            {
                x: xTo + 1,
                y: yTo,
                d: 5,
            },
            {
                x: xTo + 1,
                y: yTo + 1,
                d: 8,
            },
            {
                x: xTo,
                y: yTo + 1,
                d: 7,
            },
        ];
    }
    // From 2
    if (xFrom === xTo && yFrom === yTo - 1) {
        return [
            {
                x: xTo - 1,
                y: yTo + 1,
                d: 6,
            },
            {
                x: xTo,
                y: yTo + 1,
                d: 7,
            },
            {
                x: xTo + 1,
                y: yTo + 1,
                d: 8,
            },
        ];
    }
    // From 3
    if (xFrom === xTo + 1 && yFrom === yTo - 1) {
        return [
            {
                x: xTo - 1,
                y: yTo,
                d: 4,
            },
            {
                x: xTo - 1,
                y: yTo + 1,
                d: 6,
            },
            {
                x: xTo,
                y: yTo + 1,
                d: 7,
            },
        ];
    }
    // From 4
    if (xFrom === xTo - 1 && yFrom === yTo) {
        return [
            {
                x: xTo + 1,
                y: yTo - 1,
                d: 3,
            },
            {
                x: xTo + 1,
                y: yTo,
                d: 5,
            },
            {
                x: xTo + 1,
                y: yTo + 1,
                d: 8,
            },
        ];
    }
    // From 5
    if (xFrom === xTo + 1 && yFrom === yTo) {
        return [
            {
                x: xTo - 1,
                y: yTo - 1,
                d: 1,
            },
            {
                x: xTo - 1,
                y: yTo,
                d: 4,
            },
            {
                x: xTo - 1,
                y: yTo + 1,
                d: 6,
            },
        ];
    }
    // From 6
    if (xFrom === xTo - 1 && yFrom === yTo + 1) {
        return [
            {
                x: xTo,
                y: yTo - 1,
                d: 2,
            },
            {
                x: xTo + 1,
                y: yTo - 1,
                d: 3,
            },
            {
                x: xTo + 1,
                y: yTo,
                d: 5,
            },
        ];
    }
    // From 7
    if (xFrom === xTo && yFrom === yTo + 1) {
        return [
            {
                x: xTo - 1,
                y: yTo - 1,
                d: 1,
            },
            {
                x: xTo,
                y: yTo - 1,
                d: 2,
            },
            {
                x: xTo + 1,
                y: yTo - 1,
                d: 3,
            },
        ];
    }
    // From 8
    if (xFrom === xTo + 1 && yFrom === yTo + 1) {
        return [
            {
                x: xTo - 1,
                y: yTo,
                d: 4,
            },
            {
                x: xTo - 1,
                y: yTo - 1,
                d: 1,
            },
            {
                x: xTo,
                y: yTo - 1,
                d: 2,
            },
        ];
    }
};
exports.availableSquaresToPushBack = availableSquaresToPushBack;
// Returns all 8 adjacent squares around the target for GRAB skill
const allAdjacentSquaresToPushBack = (p2) => {
    if (p2.x === null || p2.y === null) {
        return [];
    }
    return [
        { x: p2.x - 1, y: p2.y - 1, d: 1 },
        { x: p2.x, y: p2.y - 1, d: 2 },
        { x: p2.x + 1, y: p2.y - 1, d: 3 },
        { x: p2.x - 1, y: p2.y, d: 4 },
        { x: p2.x + 1, y: p2.y, d: 5 },
        { x: p2.x - 1, y: p2.y + 1, d: 6 },
        { x: p2.x, y: p2.y + 1, d: 7 },
        { x: p2.x + 1, y: p2.y + 1, d: 8 },
    ];
};
exports.allAdjacentSquaresToPushBack = allAdjacentSquaresToPushBack;
// playerFrom, pointTo, foe
const isOnLine = (A, B, C) => {
    // Interception table reference
    const AC = (0, calcul_1.distance)(A, C);
    const BC = (0, calcul_1.distance)(B, C);
    const AB = (0, calcul_1.distance)(A, B);
    return AC + BC >= AB - 0.1 && AC + BC <= AB + 0.7 && AC < AB;
};
exports.isOnLine = isOnLine;
const getThrowingBonus = (p1, p2, game) => {
    if (!p1 ||
        !p2 ||
        p1.x === null ||
        p1.y === null ||
        p2.x === null ||
        p2.y === null ||
        !(Number.isInteger(p1.x) &&
            Number.isInteger(p1.y) &&
            Number.isInteger(p2.x) &&
            Number.isInteger(p2.y) &&
            p1.x >= 0 &&
            p1.y >= 0 &&
            p2.x >= 0 &&
            p2.y >= 0)) {
        return null;
    }
    var dist = (0, calcul_1.distance)(p1, p2);
    //https://i.servimg.com/u/f39/16/99/72/85/la_rag12.jpg
    // lutece
    // https://farm5.static.flickr.com/4018/4538693708_6e13fee995_o.jpg
    //empireoublie.free.fr/docs/table_intercept.pdf
    //https://play.google.com/store/apps/details?id=com.cyberedelf.interception
    if (dist < 1 || dist >= (0, meteo_1.meteoMaxPassDistance)(game.meteo)) {
        return null;
    }
    if (dist >= 1 && dist < 3.5) {
        return 1;
    }
    if (dist >= 3.5 && dist < 7) {
        return 0;
    }
    if (dist >= 7 && dist < 10.2) {
        return -1;
    }
    // if (dist >= 10.2 && dist < 13.03840481040529919454229457187466324) -> never finish...
    if (dist >= 10.2 && dist < 13.1) {
        if ((Math.abs(p2.x - p1.x) === 5 && Math.abs(p2.y - p1.y) === 12) ||
            (Math.abs(p2.x - p1.x) === 7 && Math.abs(p2.y - p1.y) === 11) ||
            (Math.abs(p2.x - p1.x) === 11 && Math.abs(p2.y - p1.y) === 7) ||
            (Math.abs(p2.x - p1.x) === 12 && Math.abs(p2.y - p1.y) === 5)) {
            return null;
        }
        else {
            return -2;
        }
    }
    return null;
};
exports.getThrowingBonus = getThrowingBonus;
const isOnField = (x, y, w, h) => {
    return (Number.isInteger(x) &&
        Number.isInteger(y) &&
        Number.isInteger(w) &&
        Number.isInteger(h) &&
        !(x >= w || y >= h || x < 0 || y < 0));
};
exports.isOnField = isOnField;
const canPlayerIntercepts = (playerFrom, player, pointTo) => {
    return (player.teamId !== playerFrom.teamId &&
        (0, status_1.hasStatusTacleZone)(player) &&
        //  playerTo.canIntercept === true &&
        isOnLine(playerFrom, pointTo, player) &&
        !(0, skill_1.hasSkill)(player, skill_1.SKILL_NAMES.NO_HANDS));
};
exports.canPlayerIntercepts = canPlayerIntercepts;
const getBestInterceptor = (playerFrom, pointTo, players) => {
    const possiblePlayers = players.filter((foe) => {
        return canPlayerIntercepts(playerFrom, foe, pointTo);
    });
    // Take best AG
    let bestAG = -Infinity;
    let bestAGPlayers = [];
    possiblePlayers.forEach((player) => {
        // TODO : Check if this is correct, format is not correct
        //   players: Record<string, PlayerWithSkill> ??
        // const zdt = getEnemyTackleZones(player, player.teamId, players).length;
        const zdt = (0, position_1.getEnemyTackleZones)({ x: player.x, y: player.y }, player.teamId, players.reduce((acc, player) => {
            acc[player.id] = player;
            return acc;
        }, {})).length;
        const disturbingPresence = (0, skill_1.getDisturbingPresenceMalus)(player, players);
        let bonus = 0;
        if ((0, skill_1.hasSkill)(player, skill_1.SKILL_NAMES.EXTRA_ARMS)) {
            bonus += 1;
        }
        if ((0, skill_1.hasSkill)(player, skill_1.SKILL_NAMES.VERY_LONG_LEGS)) {
            bonus += 2;
        }
        const total = player.current_AG - zdt - disturbingPresence + bonus;
        if (total > bestAG) {
            bestAG = total;
            bestAGPlayers = [];
            bestAGPlayers.push(player);
        }
        else if (total === bestAG) {
            bestAGPlayers.push(player);
        }
    });
    // Take closest if multiple best AG
    let bestDistance = Infinity;
    let bestDistancePlayer = null;
    bestAGPlayers.forEach((player) => {
        const d = (0, calcul_1.distance)(playerFrom, player);
        if (bestDistancePlayer === null || d < bestDistance) {
            bestDistance = d;
            bestDistancePlayer = player;
        }
    });
    return bestDistancePlayer;
};
exports.getBestInterceptor = getBestInterceptor;
function canBlock(attacker, defender, attackerTeam, game, withModif = true, checkBlitz = true) {
    if (!attacker ||
        !defender ||
        !attackerTeam ||
        isSamePlayer(attacker, defender)) {
        return false;
    }
    if (haveSameTeam(attacker, defender)) {
        return false;
    }
    if (!(0, status_1.hasStatusTacleZone)(attacker) || !(0, status_1.hasStatusStanding)(defender)) {
        return false;
    }
    if (!(0, position_1.isAdjacent)(attacker, defender)) {
        return false;
    }
    if (attacker.has_action === false) {
        return false;
    }
    if (checkBlitz) {
        // No blitz available
        if (attackerTeam.date_next_blitz !== null) {
            const value = withModif
                ? (0, player_1.getMaxCarac)(attacker, player_1.PLAYER_CARAC.MA, game)
                : attacker.MA;
            return attacker.current_MA === value;
        }
        else {
            // Blitz available
            // No more move
            if (+attacker.current_MA <= 0 && +attacker.current_gfi <= 0) {
                return false;
            }
        }
    }
    return true;
}
function canFoul(attacker, defender, attackerTeam) {
    if (!attacker || !defender || isSamePlayer(attacker, defender)) {
        return false;
    }
    return (attacker.has_action === true &&
        !haveSameTeam(attacker, defender) &&
        (0, status_1.hasStatusTacleZone)(attacker) &&
        (0, status_1.hasStatusFall)(defender) &&
        attackerTeam.date_next_foul === null &&
        (0, position_1.isAdjacent)(attacker, defender));
}
function canPass(player, playerTeam, playerIdWithBall) {
    return (player.status !== status_1.PLAYER_STATUS.BLOODLUST &&
        (0, status_1.hasStatusTacleZone)(player) &&
        player.has_action === true &&
        playerTeam.date_next_pass === null &&
        player.id === playerIdWithBall);
}
function canEndTurn(player, game) {
    return ((0, status_1.hasStatusOnField)(player) &&
        player.date_next_action === null &&
        (player.has_action === false || (0, player_1.hasMove)(player, game)));
}
function canThrowTeamMate(player, target, playerTeam) {
    return (player &&
        target &&
        haveSameTeam(player, target) &&
        (0, status_1.hasStatusTacleZone)(player) &&
        player.has_action === true &&
        playerTeam.date_next_pass === null &&
        (0, position_1.isAdjacent)(player, target) &&
        (0, skill_1.hasSkill)(player, skill_1.SKILL_NAMES.THROW_TEAM_MATE) &&
        (0, skill_1.hasSkill)(target, skill_1.SKILL_NAMES.RIGHT_STUFF) &&
        player.current_ST >= 5 &&
        target.current_ST <= 3);
}
function canMove(player, nbTile = 1) {
    return ((0, status_1.hasStatusTacleZone)(player) &&
        player.current_MA + player.current_gfi >= nbTile);
}
function canTransmit(player, target, playerTeam, playerIdWithBall) {
    if (!player || !target || isSamePlayer(player, target)) {
        return false;
    }
    // Cannot transmit from or to a player in Bloodlust state
    if (player.status === status_1.PLAYER_STATUS.BLOODLUST) {
        return false;
    }
    if (target.status === status_1.PLAYER_STATUS.BLOODLUST) {
        return false;
    }
    if (player.id !== playerIdWithBall && target.id !== playerIdWithBall) {
        return false;
    }
    // Cannot transmit if player has already ended turn (e.g., after Bloodlust bite)
    if (player.hasEndTurn === true) {
        return false;
    }
    return (player.teamId === target.teamId &&
        playerTeam.date_next_transmission === null &&
        (0, status_1.hasStatusTacleZone)(player) &&
        (0, status_1.hasStatusTacleZone)(target) &&
        (0, position_1.isAdjacent)(player, target));
}
function canStandup(player) {
    return player.has_action === true && (0, status_1.hasStatusCanStandup)(player);
}
function canFaceUp(player) {
    return player.has_action === true && (0, status_1.hasStatusCanFaceup)(player);
}
// *************************** Field *****************************
function isGameRunning(game) {
    return (game.status === game_1.GAME_STATUS.BEFORE ||
        game.status === game_1.GAME_STATUS.ONGOING ||
        game.status === game_1.GAME_STATUS.TD ||
        game.status === game_1.GAME_STATUS.HALFTIME);
}
function isSetUp(game) {
    return (game.status === game_1.GAME_STATUS.BEFORE ||
        game.status === game_1.GAME_STATUS.TD ||
        game.status === game_1.GAME_STATUS.HALFTIME);
}
function getTeamColor(game, side) {
    return side === 1
        ? game.team1
            ? game.team1.color1
            : null
        : game.team2
            ? game.team2.color2
            : null;
}
const isCoach = (player, team = null) => {
    return player && team && team.coach_id === player.id;
};
exports.isCoach = isCoach;
const getMoralModifier = (player) => {
    if (player.experience == null) {
        throw Error("empty experience player");
    }
    const career = (0, race_1.getCareerFromPlayer)(player);
    let range = improvement_1.ranges.findIndex((range) => player.experience < range);
    if (range === -1) {
        range = improvement_1.ranges.length;
    }
    return career.cost / 10 + range;
};
exports.getMoralModifier = getMoralModifier;
const getTeamXP = (team) => {
    let xp = 0;
    for (const player of team.players) {
        xp += player.experience;
    }
    return xp;
};
exports.getTeamXP = getTeamXP;
const getTeamMoral = (team) => {
    let moral = 0;
    for (const player of team.players) {
        moral += getMoralModifier(player);
    }
    return moral;
};
exports.getTeamMoral = getTeamMoral;
const getTeamMoralByPlayer = (team) => {
    return Math.round(getTeamMoral(team) / team.players.length);
};
exports.getTeamMoralByPlayer = getTeamMoralByPlayer;
const getAttackerStrength = (player, isBlitz = false, meteoValue = meteo_1.METEO.PERFECT_CONDITION) => {
    try {
        let bonus = isBlitz ? (0, meteo_1.meteoAttackerStrengthBlitz)(meteoValue) : 0;
        const hasHorn = (0, skill_1.hasSkill)(player, skill_1.SKILL_NAMES.HORNS);
        bonus += isBlitz && hasHorn ? 1 : 0;
        return player.current_ST + bonus;
    }
    catch (e) {
        throw new Error(`Error in getAttackerStrength: ${e}`);
    }
};
exports.getAttackerStrength = getAttackerStrength;
const getDefenderStrength = (player) => {
    return player.current_ST;
};
exports.getDefenderStrength = getDefenderStrength;
const arrayMove = (arr, old_index, new_index) => {
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
};
exports.arrayMove = arrayMove;
const swapArrayLocs = (arr, index1, index2) => {
    var temp = arr[index1];
    arr[index1] = arr[index2];
    arr[index2] = temp;
    return arr;
};
exports.swapArrayLocs = swapArrayLocs;
const getInactiveDays = (isDev = false) => {
    return isDev ? 10000 : INACTIVE_DAYS;
};
exports.getInactiveDays = getInactiveDays;
const getMaxPlayers = (isDev = false) => {
    let maxPlayers = MAX_PLAYER_USER;
    if (isDev) {
        maxPlayers = 10000;
    }
    return maxPlayers;
};
exports.getMaxPlayers = getMaxPlayers;
var sidestep_1 = require("./skills/sidestep");
Object.defineProperty(exports, "SidestepMode", { enumerable: true, get: function () { return sidestep_1.SidestepMode; } });
Object.defineProperty(exports, "SidestepStrategy", { enumerable: true, get: function () { return sidestep_1.SidestepStrategy; } });
var hitAndRun_1 = require("./skills/hitAndRun");
Object.defineProperty(exports, "HitAndRunMode", { enumerable: true, get: function () { return hitAndRun_1.HitAndRunMode; } });
Object.defineProperty(exports, "HitAndRunStrategy", { enumerable: true, get: function () { return hitAndRun_1.HitAndRunStrategy; } });
var safePairOfHands_1 = require("./skills/safePairOfHands");
Object.defineProperty(exports, "SafePairOfHandsMode", { enumerable: true, get: function () { return safePairOfHands_1.SafePairOfHandsMode; } });
Object.defineProperty(exports, "SafePairOfHandsStrategy", { enumerable: true, get: function () { return safePairOfHands_1.SafePairOfHandsStrategy; } });
